import {
  CategoryResponse,
  SingleCategoryResponse,
  CreateCategoryResponse,
  UpdateCategoryResponse,
} from '@/types/categories/category';
import { httpServices } from '../axiosClient';
import { ApiResponse } from '@/types';

export interface ListCategoriesParams {
  page?: number;
  page_size?: number;
  enabled?: boolean;
  organization_id?: string;
}

export interface CreateCategoryRequest {
  name: string;
  enabled?: boolean;
  default?: boolean;
}

export interface UpdateCategoryRequest {
  name?: string;
  enabled?: boolean;
  default?: boolean;
}

export const listCategories = async (
  params?: ListCategoriesParams,
): Promise<CategoryResponse> => {
  const response = await httpServices.llmService.get<CategoryResponse>(
    '/category',
    params,
  );
  return response;
};

export const getCategory = async (
  categoryId: number,
): Promise<SingleCategoryResponse> => {
  const response = await httpServices.llmService.get<SingleCategoryResponse>(
    `/category/${categoryId}`,
  );
  return response;
};

export const createCategory = async (
  data: CreateCategoryRequest,
): Promise<CreateCategoryResponse> => {
  const response = await httpServices.llmService.post<CreateCategoryResponse>(
    '/category',
    data,
  );
  return response;
};

export const updateCategory = async (
  categoryId: number,
  data: UpdateCategoryRequest,
): Promise<UpdateCategoryResponse> => {
  const response = await httpServices.llmService.put<UpdateCategoryResponse>(
    `/category/${categoryId}`,
    data,
  );
  return response;
};

export const deleteCategory = async (
  categoryId: number,
): Promise<ApiResponse<null>> => {
  const response = await httpServices.llmService.delete<ApiResponse<null>>(
    `/category/${categoryId}`,
  );
  return response;
};
